export default __webpack_public_path__ + "static/media/info_blue.a8909a29.svg";